import {
    updateUrlParams,
    wizardStepExited,
    wizardStepStarted
} from '../../../store/wizard/action_creators';
import React, { useEffect, useMemo, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { buildServersList, getPropFromState } from '../../../utils/mapStateToPropsUtils';
import WeStepTemplate from "./WeStepTemplateNew";
import { capitalize, find } from 'lodash'
import FsxWeCard from "./FsxWeCardNew";
import "./cmWeStepNew.scss";
import useStepinize from "../useStepinize";
import { getWizardParamsFromWizardState } from "../../../utils/mapStateToPropsUtils";
import { useGetRegisterdFileSystemsQuery, useLazyGetFileSystemsQuery } from '../../../syncNew/api/blueXp.slice';
import rootSelector from '../../../syncNew/store/selectors/root.selector';
import fsxDefaultSvg from '../../../assets/svgs/fsx-default.svg?url';

const loading = () => {
    return {
        className: 'cvo-we',
        text: 'System',
        icon: fsxDefaultSvg
    }
}

const stepId = ({ isTargetStepFromSameSourceType, protocol }) => {
    const protocolCapitalized = capitalize(protocol);
    return isTargetStepFromSameSourceType ? `targetFsx${protocolCapitalized}We` : `fsx${protocolCapitalized}We`;
};
const fetchData = (props) => {
    props.getFSXWorkingEnvironments();
};

const FsxWeStep = (props) => {
    const FS_STATUS_NOT_SET = '__notSet';
    const [accumulatedFsStatus, setAccumulatedFsStatus] = useState({});

    const { accountId, workspaceId } = useSelector(rootSelector.accountInfo);

    const { data: registeredFileSystemData, isFetching: isFetchingRegisteredFileSystem } = useGetRegisterdFileSystemsQuery({ accountId, workspaceId }, { skip: !accountId });
    const { items: fileSystems = [] } = registeredFileSystemData || {};
    const [getFileSystemsQuery] = useLazyGetFileSystemsQuery();

    const shouldFetch = () => false;

    const { LoadingComp, moreStepInfo } = useStepinize({ props, fetchData, shouldFetch, loading, stepId })
    const { isTargetStepFromSameSourceType, isSourceStep, protocol } = moreStepInfo;

    const { _cmIntegration: { inputDetails }, clearSelectedParams, state } = props;
    const { viewDashboard, source, target } = inputDetails || {};
    const protocolCapitalized = capitalize(protocol);

    //in case it was selected in the CM gallery
    const showOnlyCmSelection = (isSourceStep ? source?.sourceWorkingEnvironmentType?.toLowerCase() === "fsx" : target?.targetWorkingEnvironmentType?.toLowerCase() === 'fsx') && !viewDashboard;
    const workingEnvironmentName = isSourceStep ? source?.sourceWorkingEnvironmentName : target?.targetWorkingEnvironmentName;

    useEffect(() => {
        if (fileSystems) {
            fileSystems.forEach(we => {
                const { id, credentialsId, region } = we;
                setAccumulatedFsStatus({ [we.id]: FS_STATUS_NOT_SET });

                getFileSystemsQuery({ accountId, credentialsId, region, fsId: id }).then(({ data }) => {
                    const { status } = data || { status: 'UNAVAILABLE' };

                    setAccumulatedFsStatus(accumulatedFsStatus => {
                        return {
                            ...accumulatedFsStatus,
                            [we.id]: status
                        }
                    });
                });
            })
        }
    }, [accountId, fileSystems, getFileSystemsQuery]);

    const fsxWorkingEnvironments = useMemo(() => {
        const selectedWe = find(fileSystems, { name: workingEnvironmentName });
        const fx = showOnlyCmSelection && selectedWe ? [selectedWe] : fileSystems;

        const getStatus = (we) => {
            return accumulatedFsStatus[we.id]?.status === 'AVAILABLE' ? 'ON' : 'OFF';
        }

        const workingFx = fx.map(we => {
            return {
                ...we,
                providerDetails: {
                    status: {
                        status: getStatus(we)
                    }
                }
            };
        });

        return workingFx.filter(we => we.providerDetails.status.status === 'ON');
        // return workingFx;
    }, [accumulatedFsStatus, fileSystems, showOnlyCmSelection, workingEnvironmentName]);

    //initialize selection:
    const stepOptions = {
        workingEnvironments: fsxWorkingEnvironments,
        selectedStepParamName: `selectedFsx${protocolCapitalized}We`,
        selectedTargetStepParamName: `selectedFsx${protocolCapitalized}WeTarget`,
        showOnlyCmSelection,
        WECard: FsxWeCard,
        getSelectedParams: (we) => {
            const paramName = isTargetStepFromSameSourceType ? `fsx${protocolCapitalized}WeTarget` : `fsx${protocolCapitalized}We`

            if (state[paramName] && state[paramName] !== we) {
                const hostParam = isTargetStepFromSameSourceType ? `${protocol}ServerTarget` : `${protocol}Server`;
                const versionParam = isTargetStepFromSameSourceType ? `target${protocolCapitalized}Version` : `${protocol}Version`;
                const volParam = isTargetStepFromSameSourceType ? `${protocol}VolTarget` : `${protocol}Vol`;
                const wordForExport = protocol === 'cifs' ? 'share' : 'export';
                const wordForExportCapitalized = capitalize(wordForExport);
                const exportParam = isTargetStepFromSameSourceType ? `root${wordForExportCapitalized}Target` : `root${wordForExportCapitalized}`;
                const pathParam = isTargetStepFromSameSourceType ? `${wordForExport}PathTarget` : `${wordForExport}Path`;

                const stateParamsToClear = [exportParam, volParam, versionParam, hostParam, pathParam];

                clearSelectedParams(stateParamsToClear);
            }



            return {
                [paramName]: we
            }
        }

    }
    return (isFetchingRegisteredFileSystem || Object.values(accumulatedFsStatus).some(value => value === FS_STATUS_NOT_SET) ? LoadingComp : <WeStepTemplate stepOptions={stepOptions} {...props} {...moreStepInfo} />)
}


const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        _servers: buildServersList(state),
        _wizard: getWizardParamsFromWizardState(state, ownProps, ownProps.state)._wizard,
        _relationships: getPropFromState(state, "_relationships", {}),
        _cmIntegration: state.global._cmIntegration,
        routing: state.router,
    }
};

const mapDispatchToProps = {
    updateUrlParams,
    wizardStepStarted,
    wizardStepExited
};

export default connect(mapStateToProps, mapDispatchToProps)(FsxWeStep);
